// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "version": "c710de1e89e4244ae64fa2c62b9d220dc7d86c5e"
};
/* tslint:enable */
